import axios from 'axios'

export const apiUrl = process.env.REACT_APP_API_URL || ''
export const version = process.env.REACT_APP_VERSION || 'unknown'

export const httpProxy = axios.create({
  baseURL: `${apiUrl}/api/v1/`,
  timeout: 45000,
})
